import React, { useMemo } from 'react'
import { useAppSelector } from 'redux/toolkit/hooks'
import VerifyMsDomain from './verifyMsDomain/VerifyMsDomain'
import VerifyDomain from './verifyDomain/VerifyDomain'

const VerifyDomainSelector: React.FC = () => {
  const { microsoftConnected, microsoftVerifiedDomains } = useAppSelector(_store => ({
    microsoftConnected: _store.emailServer.emailServerSettings?.microsoftConnected,
    microsoftVerifiedDomains: _store.emailServer.emailServerSettings?.microsoftVerifiedDomains
  }))

  return useMemo(() => {
    if (microsoftConnected && microsoftVerifiedDomains && microsoftVerifiedDomains.length > 0) {
      return <VerifyMsDomain />
    }
    if (!microsoftConnected || (microsoftVerifiedDomains && microsoftVerifiedDomains.length === 0)) {
      return <VerifyDomain />
    }
    return null
  }, [microsoftConnected, microsoftVerifiedDomains])
}

export default VerifyDomainSelector
